// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"32a7def1","171":"6dde6c9e","396":"05a1ad21","910":"ff2a09ee"}[chunkId] + ".chunk.js";
};